// extracted by mini-css-extract-plugin
export default {"notifications":"styles_notifications__Ei3iX"};